import React, { useState } from "react";
import { TextField, IconButton } from "@mui/material";
import { ReactComponent as DeleteIcon } from "../../assets/dashboardIcons/deleteIcon.svg";
import "./NotificationSidebar.scss";

const NotificationSidebar = () => {
  const [selectedTab, setSelectedTab] = useState("new"); // Track selected tab
  const [searchQuery, setSearchQuery] = useState("");

  // Mock notifications (some are new, some are old)
  const notifications = [
    { title: "Anomalia sensore", description: "Nuovo avviso", isNew: true },
    { title: "Errore sistema", description: "Risolto", isNew: false },
    { title: "Malfunzionamento", description: "Analisi in corso", isNew: true },
    { title: "Manutenzione richiesta", description: "Attenzione", isNew: false },
  ];

  // Filter notifications based on the selected tab and search query
  const filteredNotifications = notifications.filter((notification) => {
    const matchesSearch =
      notification.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
      notification.description.toLowerCase().includes(searchQuery.toLowerCase());

    if (selectedTab === "new") return notification.isNew && matchesSearch;
    return matchesSearch; // Show all notifications if "all" is selected
  });

  return (
    <div className="notification">
      <p className="notification__title">Gestione notifiche</p>
      <TextField
        className="customSearchBox"
        placeholder="Cerca notifiche"
        size="small"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
      />

      {/* Tabs with Click Functionality */}
      <div className="notification__tabs">
        <p
          className={`notification__singleTab ${selectedTab === "new" ? "activeTab" : ""}`}
          onClick={() => setSelectedTab("new")}
        >
          Solo nuove notifiche
        </p>
        <p
          className={`notification__singleTab ${selectedTab === "all" ? "activeTab" : ""}`}
          onClick={() => setSelectedTab("all")}
        >
          Tutte notifiche
        </p>
      </div>

      {/* Notification List */}
      <ul className="boxContainer__lists">
        {filteredNotifications.length > 0 ? (
          filteredNotifications.map((notification, index) => (
            <li key={index} className="boxContainer__list notificationList">
              <div className="boxContainer__flexBox flexNotification">
                <div>
                  <p className={`boxContainer__flexBox-text notificationText ${notification.isNew ? "upper" : "faded"}`}>
                    {notification.title}
                  </p>
                  <p className={`boxContainer__flexBox-text notificationText ${notification.isNew ? "lower" : "faded"}`}>
                    {notification.description}
                  </p>
                </div>
                <IconButton edge="end" className="deleteBtn">
                  <DeleteIcon />
                </IconButton>
              </div>
            </li>
          ))
        ) : (
          <p className="no-notifications">Nessuna notifica trovata</p>
        )}
      </ul>
    </div>
  );
};

export default NotificationSidebar;
